import { render } from "./editIncheckComponent.vue?vue&type=template&id=6b5d47e0"
import script from "./editIncheckComponent.vue?vue&type=script&lang=js"
export * from "./editIncheckComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__